var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.0262,
    cy: 14.0262,
    r: 14.0262,
    fill: "#F7F8FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8105 7.21262C17.0918 6.93141 17.4733 6.77344 17.871 6.77344C18.2688 6.77344 18.6502 6.93141 18.9315 7.21262L20.7878 9.06887C20.9271 9.20816 21.0377 9.37355 21.1131 9.55558C21.1885 9.7376 21.2273 9.93271 21.2273 10.1297C21.2273 10.3268 21.1885 10.5219 21.1131 10.7039C21.0377 10.8859 20.9271 11.0513 20.7878 11.1906L11.868 20.1104L7.08301 20.9174L7.89076 16.1324L16.8105 7.21262ZM16.6388 9.50537L18.495 11.3616L19.7273 10.1294L17.871 8.27387L16.6388 9.50537ZM17.4338 12.4229L15.5783 10.5666L9.29026 16.8546L8.91301 19.0874L11.1458 18.7109L17.4338 12.4229Z",
    fill: "#626262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.bc934132c4ea4e39125621959a397f73.svg";
export { ForwardRef as ReactComponent };